const NO_GAME_INVITATIONS_ID = "game-invitation-none"
const GAME_INVITATIONS_ID = "game-invitations"
const GAME_INVITATION_TEMPLATE_ID = "game-invitation-template"
const GAME_IN_PROGRESS_ID ="game-in-progress-template"

const GAME_INVITATION_CLASS = "game-invitation"
const GAME_TITLE_CLASS = "uk-card-title"
const GAME_INVITATION_BADGE_CLASS = "uk-card-badge"
const PLAYER_PENDING_RESPONSE_CLASS = "player-pending-response"
const PLAYER_ACCEPTED_CLASS = "player-accepted"
const ACCEPT_BUTTON_CLASS = "accept-button"
const PLAYERS_CLASS = "players"

function noGameInvitations() {
  const noGameInvitations = document.getElementById(NO_GAME_INVITATIONS_ID)
  noGameInvitations.hidden = false
  removeOldInvites()
}

function removeOldInvites() {
  const gameInvitations = document.getElementById(GAME_INVITATIONS_ID)
  const allGameInvitations = [...gameInvitations.getElementsByClassName(GAME_INVITATION_CLASS)]
  for (let i = 0; i < allGameInvitations.length; i++) {
    if (allGameInvitations[i].id !== GAME_INVITATION_TEMPLATE_ID) {
      allGameInvitations[i].remove()
    }
  }
}

function renderGameInvitation(game) {
  const userEmail = ID.user.getBasicProfile().getEmail()
  const gameInvitations = document.getElementById(GAME_INVITATIONS_ID)
  const template = document.getElementById(GAME_INVITATION_TEMPLATE_ID)
  const newGameInvitation = template.cloneNode(true)
  newGameInvitation.id = ""
  newGameInvitation.hidden = false
  newGameInvitation.getElementsByClassName(GAME_TITLE_CLASS)[0].innerText = `Game: ${game.name}`
  const badge = newGameInvitation.getElementsByClassName(GAME_INVITATION_BADGE_CLASS)[0]
  const acceptButton = newGameInvitation.getElementsByClassName(ACCEPT_BUTTON_CLASS)[0]
  acceptButton.onclick = () => acceptGameInvite(game.game_id)
  badge.innerText = game.players[userEmail].accepted ? "accepted" : "pending"
  if (game.players[userEmail].accepted) {
    badge.classList.replace("uk-label-default", "uk-label-success")
    acceptButton.disabled = true
  } else {
    badge.classList.replace("uk-label-success", "uk-label-default")
  }
  const acceptedTemplate = newGameInvitation.getElementsByClassName(PLAYER_ACCEPTED_CLASS)[0]
  const pendingTemplate = newGameInvitation.getElementsByClassName(PLAYER_PENDING_RESPONSE_CLASS)[0]
  const playerNodes = []
  for (let player in game.players) {
    const playerNode = game.players[player].accepted ? acceptedTemplate.cloneNode(true) : pendingTemplate.cloneNode(true)
    playerNode.hidden = false
    playerNode.innerText = player
    playerNodes.push(document.createTextNode(", "))
    playerNodes.push(playerNode)
  }
  // drop the first element and reverse the list 
  for (let j = playerNodes.length - 1; j > 0; j--) {
    newGameInvitation.appendChild(playerNodes[j])
  }
  gameInvitations.appendChild(newGameInvitation)
}

function renderGameInProgress(game) {
  const template = document.getElementById(GAME_IN_PROGRESS_ID)
  const newGameInProgress = template.cloneNode(true)
  newGameInProgress.id = ""
  newGameInProgress.hidden = false
  newGameInProgress.getElementsByClassName(GAME_TITLE_CLASS)[0].innerText = `Game: ${game.name}`

  newGameInProgress.onclick = () => window.location = `/game?game_id=${game.game_id}`

  const playersList = newGameInProgress.getElementsByClassName(PLAYERS_CLASS)[0]
  playersList.innerHTML = Object.keys(game.players).join(", ")
  template.parentElement.appendChild(newGameInProgress)
}

function showGameInvitations(games) {
  const noGameInvitations = document.getElementById(NO_GAME_INVITATIONS_ID)
  noGameInvitations.hidden = true
  removeOldInvites()
  for (let i = 0; i < games.length; i++) {
    const game = games[i]
    if (Object.values(game.players).every(player => player.accepted)) {
      renderGameInProgress(game)
    } else {
      renderGameInvitation(game)
    }
  }
}

async function acceptGameInvite(game_id) {
  try {
    const response = await fetch("/.netlify/functions/acceptGameInvite", {
      method: 'POST',
      headers: {
        authorization: `Bearer ${ID.user.getAuthResponse().id_token}`
      },
      body: JSON.stringify({
        game_id
      })
    })
    const responseBody = await response.json();
    if (!response.ok) {
      console.error(responseBody.msg)
      return
    }
    getGameInvites()
  }
  catch (err) {
    console.error(err)
  }
}

export async function getGameInvites() {
  try {
    const response = await fetch(`/.netlify/functions/getGamesForUser`, {
      method: 'GET',
      headers: {
        authorization: `Bearer ${ID.user.getAuthResponse().id_token}`
      }
    })
    const responseBody = await response.json();
    if (!response.ok) {
      noGameInvitations()
      console.error(responseBody.msg)
      return
    }
    if (responseBody.games.length === 0) {
      noGameInvitations()
    } else {
      showGameInvitations(responseBody.games)
    }
  }
  catch (err) {
    console.error(err)
  }
}
